var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMemorial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 81,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.452 75.84h-2.65V65.55a2.339 2.339 0 00-2.34-2.34h-5.144V13.165a2.339 2.339 0 00-2.339-2.339h-4.272C47.867 4.701 41.757.691 35.023.691c-6.735 0-12.845 4.01-15.685 10.134h-4.272a2.339 2.339 0 00-2.338 2.339V63.21H7.583a2.339 2.339 0 00-2.339 2.338v10.29h-2.65a2.339 2.339 0 000 4.677h64.858a2.339 2.339 0 000-4.677zM17.405 15.501h3.503c.992 0 1.875-.625 2.206-1.56 1.81-5.128 6.597-8.574 11.909-8.574s10.098 3.446 11.91 8.575a2.339 2.339 0 002.204 1.56h3.504V63.21H17.405V15.502zM9.921 67.888v7.951h50.203v-7.951H9.921z",
    fill: "#404457"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.034 22.986h2.65v6.392a2.339 2.339 0 004.678 0v-6.392h2.65a2.339 2.339 0 100-4.677h-2.65v-2.65a2.339 2.339 0 00-4.678 0v2.65h-2.65a2.339 2.339 0 000 4.677zM45.001 38.265H25.045a2.339 2.339 0 000 4.677H45a2.339 2.339 0 000-4.677zM45.001 50.738H25.045a2.339 2.339 0 000 4.677H45a2.339 2.339 0 000-4.677z",
    fill: "#404457"
  })));
}

export default SvgMemorial;